import { MailIcon } from "@heroicons/react/outline";
import { useState } from "react";
import toast from "react-hot-toast";
import {
  Analytics,
  EventAction,
  EventObject,
} from "services/analytics.service";
import { ApiService } from "services/api.service";
import Button, { ButtonShade } from "../library/Button";
import { LoadingIcon } from "../library/Icons";
import { classNames } from "../library/utils/classNames";

// Copy of NewsletterSignUp pointing to different form

const GPT3SignUp = ({ shade }: { shade?: "blue" | "black" }) => {
  const buttonText = "Request Access";
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: "",
  });
  const [signedUp, setSignedUp] = useState(false);

  const handleSubmit = async (
    e: React.FormEvent<HTMLFormElement> | React.MouseEvent
  ) => {
    e.preventDefault();
    setLoading(true);
    Analytics.identify(form.email, { email: form.email });
    Analytics.track(EventObject.Form, EventAction.Submitted, {
      form: "gpt3-signup",
      email: form.email,
    });
    try {
      const result = await ApiService.post(
        "/api/gpt3-signup",
        form,
        {},
        (e, method, url, data, config) => {
          const message = e?.response?.data?.message;
          console.log("Failed to fetch:", e, method, url, data, config);
          if (message) {
            toast.error(message);
          }
        }
      );
      if (result.status === 200) {
        setSignedUp(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-16 sm:min-w-[350px]">
      <div className="text-14-20 text-gray-600">
        Request access to the Humanloop closed beta
      </div>
      {signedUp ? (
        <div className="border-b border-gray-400">
          <div className="flex h-[44px] items-center py-8 text-14-20 text-gray-800 md:h-52">
            Request received! We&apos;ll get in touch shortly.
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="flex justify-center gap-12 border-b border-gray-400">
            <div className="relative grow rounded">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-12">
                <MailIcon
                  className="h-24 w-24 text-gray-400"
                  aria-hidden="true"
                />
              </div>
              <input
                type="email"
                name="email"
                id="email"
                required
                className="form-input block h-[44px] w-full border-0 pl-48 pr-[140px] text-14-20 text-black ring-0 focus:ring-0 md:h-52"
                placeholder="your email"
                value={form.email}
                onChange={(e) => {
                  setForm({
                    ...form,
                    email: e.target.value,
                  });
                }}
              />
              <div className="absolute inset-y-0 right-0 flex items-center">
                <Button
                  type="submit"
                  styling="ghost"
                  shade={ButtonShade.Gray}
                  className={classNames(
                    shade === "black" && "!bg-black",
                    "whitespace-nowrap",
                    loading ? "pl-20 pr-16" : "px-32",
                    "!font-normal"
                  )}
                  square
                  loading={loading}
                  IconRight={loading ? LoadingIcon : undefined}
                  size={40}
                >
                  {buttonText}
                </Button>
              </div>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default GPT3SignUp;
